import { atom, useAtomValue, useSetAtom } from 'jotai';
import { getReturnCancelCountV2 } from 'services/api/refund';
import { noop } from 'lodash-es';

export const openReturnStatus = atom<boolean>(false);
export const useOpenReturnStatus = () => {
  return useAtomValue(openReturnStatus);
};
export const useSetOpenReturnStatus = () => {
  return useSetAtom(openReturnStatus);
};

export const returnCancelCountState = atom({
  total: 0,
  shopeeReturnCount: 0,
  shopeeCancelCount: 0,
  lazadaReturnCount: 0,
  lazadaCancelCount: 0,
  shopeeTotalCount: 0,
  lazadaTotalCount: 0,
  tiktokReturnCount: 0,
  tiktokCancelCount: 0,
  tiktokTotalCount: 0,
  tiktokUsReturnCount: 0,
  tiktokUsCancelCount: 0,
  tiktokUsTotalCount: 0,
  mercadoTotalCount: 0,
  mercadoClaimCount: 0,
  mercadoReturnCount: 0,
  kwaiTotalCount: 0,
});

export const useReturnCancelCount = () => {
  return useAtomValue(returnCancelCountState);
};
export const useSetReturnCancelCount = () => {
  const setReturnCancelCount = useSetAtom(returnCancelCountState);
  return () => {
    getReturnCancelCountV2()
      .then((res) => setReturnCancelCount(res))
      .catch(noop);
  };
};
